import { QueryClient } from '@tanstack/react-query';

// GLOBAL ERROR HANDLER
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // onError: queryErrorHandler,
      staleTime: 5000, // 5 seconds
      // cacheTime: 900000, // default cacheTime is 5 minutes; doesn't make sense for staleTime to exceed cacheTime
      // refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
    },
    mutations: {
      // onError: queryErrorHandler
    },
  }
});
